module.exports = __webpack_public_path__ + "assets/img/deals.dc73c90d.png";